import CloudUpload from '@mui/icons-material/CloudUpload'
import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import React, { useContext, useRef } from 'react'
import imageConverter from '../../../../helpers/imageConverter'
import API from '../../../../services/API'
import { GlobalContext, TenantSettingsContext } from '../../../../App'

const CompanyLogo = ({ existingLogo, onChange }) => {
  const logoInput = useRef()
  const { setToast } = useContext(GlobalContext)
  const { orgConfig } = useContext(TenantSettingsContext)

  const handleLogoUpload = async (e) => {
    try {
      e.preventDefault()
      const file = e.target.files[0]
      const logo = await imageConverter(file, 512, 512, 100)
      API.put('/orgSettings/logo', {
        logo,
      }).then((res) => {
        if (res.status === 200) {
          if (onChange) {
            onChange(logo)
          } else {
            window.location.reload()
          }
        } else {
          if (res.status === 413) {
            setToast({
              message:
                'File Size too Large. Please try again with a smaller image',
              severity: 'error',
            })
          }
        }
      })
    } catch (e) {
      console.log(e)
      setToast({
        severity: 'error',
        message: 'Unable to upload logo. Please try again later.',
      })
    }
  }
  return (
    <>
      <Grid item xs={12} lg={8}>
        <Box
          padding={1}
          borderRadius={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={100}
          border="1px solid"
          borderColor="divider"
          bgcolor="#F8FAFC"
        >
          {existingLogo ? (
            <Box
              width="100%"
              height="100%"
              sx={{
                backgroundImage: `url(${existingLogo})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            />
          ) : (
            <Stack alignItems="center" spacing={0.5} color="text.secondary">
              <CloudUpload fontSize="small" color="inherit" />
              <Typography variant="body2">No logo uploaded yet</Typography>
            </Stack>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Button
          color="secondary"
          fullWidth
          variant="contained"
          startIcon={<CloudUpload />}
          onClick={() => logoInput.current.click()}
          sx={{ minHeight: 48, height: { lg: '100%' }, borderRadius: 2 }}
        >
          Change Logo
          <input
            ref={logoInput}
            type="file"
            style={{ display: 'none' }}
            accept="image/*"
            onChange={handleLogoUpload}
          />
        </Button>
      </Grid>
    </>
  )
}

export default CompanyLogo
